export default __webpack_public_path__ + "static/media/gallery-wip-connection-rods_07.154f5d1c.jpg";